'use client';

import ClientFooterWrapper from '@/components/Layout/FooterV2/ClientFooterWrapper';
import HeaderV2 from '@/components/Layout/HeaderV2';
import { useGlobalShellInit } from '@/components/Layout/useGlobalShellInit';
import { EPlatform } from '@/utils/enums/platform-enum';
import { type GlobalInitChromeMapped } from '@/utils/map-global-init-data';
import { type ComponentProps, type ReactNode } from 'react';

export interface GlobalLayoutShellProps {
  children: ReactNode;
  deviceType: EPlatform;
  isBot: boolean;
  initialMappedData?: Partial<GlobalInitChromeMapped>;
}

/**
 * 顶栏/底栏壳层；global init 数据由 {@link useGlobalShellInit} 统一拉取。
 * 若服务端已提供 initialMappedData，则首屏直接渲染，不展示骨架屏。
 */
export default function GlobalLayoutShell({
  children,
  deviceType,
  isBot,
  initialMappedData,
}: GlobalLayoutShellProps) {
  const { mapped } = useGlobalShellInit(deviceType, initialMappedData);

  const headerNavList = (mapped.headerNavList ?? []) as ComponentProps<
    typeof HeaderV2
  >['headerNavList'];
  const footerNavList = (mapped.footerNavList ?? []) as ComponentProps<
    typeof ClientFooterWrapper
  >['navList'];
  return (
    <>
      <HeaderV2
        dtInfo={mapped.dtInfo ?? null}
        logoData={mapped.logoData ?? null}
        quickEntryData={mapped.quickEntryData ?? null}
        noticeData={mapped.noticeData ?? null}
        headerNavList={headerNavList}
        deviceType={deviceType}
      />

      {children}
      <ClientFooterWrapper navList={footerNavList} deviceType={deviceType} isBot={isBot} />
    </>
  );
}
